export default "__VITE_PUBLIC_ASSET__5b745010__"